module.controller('sampleTaskElementCtrl', [ '$scope', '$state', 'planSamplingService', 'alertService', sampleTaskElementCtrlFn ])

function sampleTaskElementCtrlFn($scope, $state, planSamplingService, alertService) {
	var vm = this;
	var vmParent = $scope.ctrl;

	vm.sampleElementsConsolidated = {};

	vm.onClickCheckSampleElement = function() {
		alertService.showSwtQuestion('confirmar los elementos de muestreo', function() {
			$scope.loading = true;

			planSamplingService.checkSampleElement($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample).then(function(response) {
				$scope.loading = false;
				$scope.ctrl.reloadData();
				if ($scope.refreshSample)
					$scope.refreshSample($scope.ctrl.idPlanSampling, $scope.ctrl.idSampling, $scope.ctrl.idSample);
				alertService.showSuccess('Elementos de muestreo confirmados satisfactoriamente');
				vmParent.goTop();
			}, function(response) {
				$scope.loading = false;
			});
		});
	}

	function sampleElementsConsolidate(sampleAnalysis) {
		var analysisByType = [];
		var lastId = -1;
		var index = 0;

		// oRDENA POR TIPO DE ANALISIS
		sampleAnalysis.sort(function(a, b) {
			return a.analysis.type.id - b.analysis.type.id;
		});
		// saca los tipos de analysis sin duplicados y agrupa los elementos de
		// muestreo
		sampleAnalysis.forEach(function(element) {
			if (element.analysis.type.id != lastId) {
				var item = {
					type : element.analysis.type,
					sampleElements : element.analysis.sampleElements,
					countSampleElements : []
				};
				analysisByType.push(item);
				lastId = element.analysis.type.id;
				index++;
			} else {
				analysisByType[index - 1].sampleElements = analysisByType[index - 1].sampleElements.concat(element.analysis.sampleElements);
			}
		});
		// consolida la cantidad de elementod e muestreo x tipo de analisis
		analysisByType.forEach(function(e) {
			lastId = -1;
			index = 0;
			// ordena los elemntos de muestreo por su id para despues hacer
			// mas facil su consolidación
			e.sampleElements.sort(function(a, b) {
				return a.id - b.id;
			});
			// contabiliza los elementos de muestreo
			e.sampleElements.forEach(function(se) {
				if (se.id != lastId) {
					var item = se;
					item.count = 1
					e.countSampleElements.push(item);
					lastId = se.id;
					index++;
				} else {
					e.countSampleElements[index - 1].count++;
				}
			});
		});

		return analysisByType;
	}

	$scope.$watch($scope.ctrl.sample, function() {
		if(!$scope.ctrl.sample)
			return;
		vm.sampleElementsConsolidated = sampleElementsConsolidate($scope.ctrl.sample.sampleAnalysisResult);
	});
}